import gql from "graphql-tag";

export const GET_USER_DATA = gql`
    query getUserData($username: String!) {
        photos: browsePhotosByCreator(creator: $username) {
            totalCount
        }
        icons: browseIconsByCreator(username: $username) {
            totalCount
        }
        info: creatorProfileDetailByUsername(username: $username) {
            id
            name
            description
            avatarUrl(size: 150)
            twitter
            facebook
            behance
            dribbble
            linkedin
            instagram
        }
    }
`;
